import { useState, useEffect } from 'react';
import getStartedSteps from './getStartedSteps';

export const STORAGE_KEY = 'onboarding_completed_tasks';

export const getCompletedTasks = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch (err) {
    console.warn('[onboarding] Error reading completed tasks:', err);
    return [];
  }
};

export const markTaskCompleted = (taskId) => {
  try {
    const stored = getCompletedTasks();
    if (!stored.includes(taskId)) {
      stored.push(taskId);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));

      const userId = localStorage.getItem('UserId');
      if (userId) {
        fetch(
          `${process.env.REACT_APP_API_URL}/userRoute/updateCompletedTasks/${userId}`,
          {
            method: 'PATCH',
            headers: {
              'Content-Type': 'application/json',
              Authorization: process.env.REACT_APP_BasicAuthSecret,
            },
            body: JSON.stringify({ completedTasks: stored }),
          }
        ).catch((err) => console.warn('[onboarding] Failed to sync tasks to backend:', err));
      }
    }
  } catch (err) {
    console.warn('[onboarding] Error saving completed task:', err);
  }
  window.dispatchEvent(new Event('onboarding:taskUpdated'));
};

const useOnboardingProgress = () => {
  const [completedTasks, setCompletedTasks] = useState(getCompletedTasks);

  const totalCount = Object.keys(getStartedSteps).length;
  const completedCount = completedTasks.length;
  const progressPct = totalCount > 0
    ? Math.round((completedCount / totalCount) * 100)
    : 0;

  useEffect(() => {
    const handleUpdate = () => setCompletedTasks(getCompletedTasks());
    window.addEventListener('onboarding:taskUpdated', handleUpdate);
    return () => window.removeEventListener('onboarding:taskUpdated', handleUpdate);
  }, []);

  return { completedTasks, totalCount, completedCount, progressPct };
};

export default useOnboardingProgress;
